<div class="modal-token-container">
  <div class="header">
    <h4>SELECT TOKEN</h4>
    <button class="close-button" (click)="closemodel()">
      <img src="assets/icons/icon-close.svg" alt="Close">
    </button>
  </div>

  <div class="token-grid">
    <!-- Display existing tokens -->
    @for (token of tokens; track token) {
      <div class="token" (click)="selectToken(token)" [class.selected]="token === selectedToken">
        <img [src]="image_url + token" alt="Token">
      </div>
    }
    <!-- Upload trigger -->
    <div class="upload-token">
      <label for="fileInput">
        <img src="assets/icons/icon-upload-outline.svg" alt="Upload">
        <span>Click to Upload</span>
      </label>
      <input type="file" id="fileInput" (change)="handleFileInput($event)" accept="image/*" style="display: none;">
    </div>
  </div>

  <div class="modal-token-footer">
    <button class="btn btn-outline" (click)="closemodel()">Cancel</button>
    <button class="btn btn-theme" (click)="confirmSelection()" [disabled]="!selectedToken">Select</button>
  </div>

  <!-- Hidden Croppie element for programmatic cropping -->
  <div #croppieElement style="visibility: hidden;height: 0px;"></div>
</div>
